export const buildNumber = '20260706.4';
export const version = '3.14.1';
export const latestCommit = '9f611fd0022e56e9d0701a9ac9a721ba454b7784';
